import { Flex } from '@chakra-ui/react';

import { Chip } from '~/components/chip';

import { getContentTypeDisplayText, getIndustryDisplayText, getKnowledgeAreaDisplayText } from '../data';

import { ContentType, Filters, Industry, KnowledgeArea } from './resource-center-filters';

export function ResourceFilterChips({
  selectedFilters,
  onFilterRemove,
}: {
  selectedFilters: Filters;
  onFilterRemove: (filterType: keyof Filters, checked: boolean, value: Industry | KnowledgeArea | ContentType) => void;
}) {
  return (
    <Flex flexWrap='wrap' gap='8px'>
      {selectedFilters.industries.map((filter) => (
        <Chip
          key={filter}
          text={getIndustryDisplayText(filter) ?? ''}
          theme='sky'
          closable
          onCloseClick={() => onFilterRemove('industries', false, filter)}
        />
      ))}
      {selectedFilters.knowledgeAreas.map((filter) => (
        <Chip
          key={filter}
          text={getKnowledgeAreaDisplayText(filter) ?? ''}
          theme='sky'
          closable
          onCloseClick={() => onFilterRemove('knowledgeAreas', false, filter)}
        />
      ))}
      {selectedFilters.contentTypes.map((filter) => (
        <Chip
          key={filter}
          text={getContentTypeDisplayText(filter) ?? ''}
          theme='sky'
          closable
          onCloseClick={() => onFilterRemove('contentTypes', false, filter)}
        />
      ))}
    </Flex>
  );
}
